var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _tspan, _tspan2, _tspan3, _path8, _tspan4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPolygonWrong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12.419 19.869",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-139.44 -145.79)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4783 0 0 .4783 76.084 82.154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m145.44 174.58c2.7998 0 5.0695-2.2697 5.0695-5.0695 0-2.7998-2.2697-5.0695-5.0695-5.0695-2.7998 0-5.0695 2.2697-5.0695 5.0695 0 2.7998 2.2697 5.0695 5.0695 5.0695z",
    fill: "#d40000",
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 12.304)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m143.87 158.78 3.1254-3.155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147 158.78-3.1254-3.155"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 139.44,
    y: 145.79,
    width: 12.419,
    height: 12.419,
    rx: 1.8797,
    ry: 1.8797,
    fill: "#fff",
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.769 1.484)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m110.44 148.21-7.1299 5.339",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66146
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m109.25 147.48h-5.3245",
    fill: "none",
    stroke: "#8895b5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66146
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m103.31 148.21 7.1299 5.339",
    fill: "none",
    stroke: "#8895b5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66146
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m109.25 153.55h-5.3245",
    fill: "none",
    stroke: "#8895b5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66146
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m104.76 153.04c-.28556-.80906-1.1678-1.236-1.9706-.95375-.80277.28229-1.2221 1.1669-.93646 1.976.28557.80905 1.1678 1.236 1.9706.95379.80282-.28231 1.2221-1.1669.9365-1.976z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m111.89 153.04c-.28553-.80906-1.1678-1.236-1.9706-.95375-.80279.28229-1.2221 1.1669-.93657 1.976.28553.80905 1.1678 1.236 1.9706.95379.80279-.28231 1.2221-1.1669.93657-1.976z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m111.89 146.96c-.28553-.8091-1.1678-1.236-1.9706-.95379-.80279.28226-1.2221 1.1669-.93657 1.976.28553.80902 1.1678 1.236 1.9706.95375.80279-.28229 1.2221-1.1669.93657-1.9759z"
  })), /*#__PURE__*/React.createElement("text", {
    x: 103.03745,
    y: 154.06006,
    fill: "#f9f9f9",
    fontFamily: "Figtree",
    fontSize: "1.4644px",
    fontWeight: "bold",
    letterSpacing: "0px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.020592,
    style: {
      lineHeight: 1.3,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 103.03745,
    y: 154.06006,
    fill: "#f9f9f9",
    strokeWidth: 0.020592
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    x: 110.03117,
    y: 154.06885,
    fill: "#f9f9f9",
    fontFamily: "Figtree",
    fontSize: "1.4644px",
    fontWeight: "bold",
    letterSpacing: "0px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.020592,
    style: {
      lineHeight: 1.3,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 110.03117,
    y: 154.06885,
    fill: "#f9f9f9",
    strokeWidth: 0.020592
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    x: 110.03264,
    y: 147.98778,
    fill: "#f9f9f9",
    fontFamily: "Figtree",
    fontSize: "1.4644px",
    fontWeight: "bold",
    letterSpacing: "0px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.020592,
    style: {
      lineHeight: 1.3,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 110.03264,
    y: 147.98778,
    fill: "#f9f9f9",
    strokeWidth: 0.020592
  }, "4"))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m104.76 146.96c-.28553-.8091-1.1678-1.236-1.9706-.95379-.80279.28226-1.2221 1.1669-.93657 1.976.28553.80902 1.1678 1.236 1.9706.95375.80279-.28229 1.2221-1.1669.93657-1.9759z"
  })), /*#__PURE__*/React.createElement("text", {
    x: 102.90273,
    y: 147.98778,
    fill: "#f9f9f9",
    fontFamily: "Figtree",
    fontSize: "1.4644px",
    fontWeight: "bold",
    letterSpacing: "0px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.020592,
    style: {
      lineHeight: 1.3,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 102.90273,
    y: 147.98778,
    fill: "#f9f9f9",
    strokeWidth: 0.020592
  }, "3"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPolygonWrong);
export default __webpack_public_path__ + "static/media/icon_polygon_wrong.ece8b91ff4a0532b491c6e92fb96ae69.svg";
export { ForwardRef as ReactComponent };